module.exports = require('jsonp');
